"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgUploader = void 0;
const React = require("react");
const FileUploader_1 = require("../FileUploader");
const Grid_1 = require("../../structure/Grid");
const ImgPreview_1 = require("../ImgPreview");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "imgUploader");
/**
 * Utilises the base FileUploader component to upload and optionally preview images.
 *
 * @note this is used by the `ImageUploadInput` input.
 */
const ImgUploader = ({ existingImages = [], onChange, maxImages = Infinity, uploadNameSpace, maxFileSize, useGuidForFileName }) => {
    const onImagesUploaded = (files) => {
        onChange && onChange([...existingImages, ...files]);
    };
    const onImageRemoved = (file) => {
        onChange && onChange(existingImages.filter(x => x.url !== file.url));
    };
    const filesLeft = maxImages - existingImages.length;
    const isDisabled = filesLeft <= 0;
    return (React.createElement("div", { "data-test": "img-uploader" },
        !Array.isArray(existingImages) && (React.createElement("div", null, "ERROR: unexpected image data")),
        Array.isArray(existingImages) && (React.createElement(FileUploader_1.FileUploader, { uploadNameSpace: uploadNameSpace, disabled: isDisabled, maxFiles: filesLeft, maxFileSize: maxFileSize, acceptedFileTypes: "image/*", onFilesUploaded: onImagesUploaded, useGuidForFileName: useGuidForFileName }, existingImages.length && (React.createElement(Grid_1.Grid, null,
            existingImages.map((x, i) => {
                return (React.createElement("div", { "data-test": `existing-image existing-image-${i}` },
                    React.createElement(ImgPreview_1.ImgPreview, { key: x.url },
                        React.createElement(ImgPreview_1.ImgPreviewMainImage, { imageUrl: x.url }),
                        React.createElement(ImgPreview_1.ImgPreviewActions, { actions: [
                                {
                                    icon: "cancel",
                                    onClick: ev => {
                                        // we don't want the event bubbling up to the dropzone!
                                        ev.stopPropagation();
                                        onImageRemoved(x);
                                    }
                                }
                            ] }))));
            }),
            !isDisabled && (React.createElement("div", { "data-test": "preview", className: css("preview") },
                React.createElement(ImgPreview_1.ImgPreview, null,
                    React.createElement(ImgPreview_1.ImgPreviewEmpty, null))))))))));
};
exports.ImgUploader = ImgUploader;
//# sourceMappingURL=index.js.map